module.exports = __webpack_public_path__ + "static/img/news79_22.ed161be.webp";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/technology/news79/news79_22.webp
// module id = Ozao
// module chunks = 0